import template from "./quote-template-import-modal.html";

const QuoteTemplateImportModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteTemplateImportModalController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $filter,
      QuoteTemplate,
      TrackingStateService,
      Notification
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.QuoteTemplate = QuoteTemplate;
      this.TrackingStateService = TrackingStateService;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.importCode = null;
    }

    async importQuoteTemplate() {
      if (!this.form.$valid) return;
      try {
        await this.QuoteTemplate.importTemplate(this.importCode);
        this.TrackingStateService.trackCustomEvent("quote-template-imported");
        this.close({ $value: true });
      } catch (e) {
        if (e.data === "Quote template with import code does not exist") {
          this.NotificationService.error({
            title: this.$filter("trans")(
              "notificationService.title.importError"
            ),
            message: this.$filter("trans")(
              "notificationService.message.templateDoesNotExist"
            ),
          });
        } else if (
          e.data === "Quote template already imported to the organization"
        ) {
          this.NotificationService.error({
            title: this.$filter("trans")(
              "notificationService.title.importError"
            ),
            message: this.$filter("trans")(
              "notificationService.message.templateAlreadyImported"
            ),
          });
        }
      }
    }

    close() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default QuoteTemplateImportModalComponent;
